export const FinalCTASection: React.FC = () => {
  return (
    <section
      id="contact"
      className="final-cta-section py-24 px-4 bg-gradient-to-b from-white to-slate-50"
    >
      <div className="container mx-auto max-w-4xl text-center">
        <div className="space-y-6">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 leading-tight">
            Request a Demo
          </h2>
          <p className="text-xl text-slate-700 max-w-2xl mx-auto leading-relaxed">
            See Ageiro ARK on a real dataset, drawings, specs, RFIs, schedules, and field reports, unified into a trusted system of intelligence teams can act on immediately.
          </p>
          <div className="flex flex-wrap justify-center gap-4 pt-8">
            <a href="https://www.ageiro.global/contact-sales" className="primary-cta px-8 py-4 rounded-xl text-lg font-semibold shadow-lg hover:shadow-xl transition-shadow">
              Request a Demo
            </a>
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-6 text-center">
          <div className="flex flex-col items-center">
            <div className="w-12 h-12 bg-violet-100 rounded-2xl flex items-center justify-center mb-3">
              <svg className="w-6 h-6 text-violet-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <h3 className="font-bold text-slate-900 mb-1">Days, Not Months</h3>
            <p className="text-sm text-slate-600">Get up and running fast</p>
          </div>
          <div className="flex flex-col items-center">
            <div className="w-12 h-12 bg-green-100 rounded-2xl flex items-center justify-center mb-3">
              <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 className="font-bold text-slate-900 mb-1">Enterprise Ready</h3>
            <p className="text-sm text-slate-600">Security and compliance built-in</p>
          </div>
          <div className="flex flex-col items-center">
            <div className="w-12 h-12 bg-purple-100 rounded-2xl flex items-center justify-center mb-3">
              <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <h3 className="font-bold text-slate-900 mb-1">Team Aligned</h3>
            <p className="text-sm text-slate-600">Everyone working from the same source</p>
          </div>
        </div>
      </div>
    </section>
  );
};
